<template>
  <div class="step">
    <img class="step-image" :src="require(`@/assets/ambassadors/step-${number}.svg`)"/>
    <span class="step-description">{{description}}</span>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {
    number: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 70px;

  .step-image {
    width: 190px;
    margin-bottom: 24px;
  }

  .step-description {
    text-align: center;
    font-size: 18px;
    line-height: 140%;
  }
}
</style>
